import React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Link } from 'react-router-dom';
import LazyLoad from 'react-lazyload';
// import PropTypes from 'prop-types';

// Components
import Button from 'components/_shared/Button/Button';
// import ErrorBoundary from 'components/_shared/ErrorBoundary/ErrorBoundary';

// Images
import Verified from "images/verified.png"
import Musician from 'images/student_musician.jpg';
import facilitateBackground from 'images/facilitate_bg_v2.png';

// SVGs
// Constants
// Services
import { reportLeaderLines, addArc } from 'services/lineCreators';

// Redux Actions
import { setSearch } from 'store/modules/db/search/searchReducer';

// Styles
import './Report.css';

export class Report extends React.Component {
  // Prop Types
  // ------------------------------------------------------------------------ //
  static propTypes = {};
  static defaultProps = {};

  // Constructor
  // ------------------------------------------------------------------------ //
  // constructor(props) {
  //   super(props);
  // }

  // Variables
  // ------------------------------------------------------------------------ //
  state = {
    pathways: null,
    lines: [],
    width: null,
  }

  // Lifecycle methods
  // ------------------------------------------------------------------------ //
  componentDidMount() {
    // setup leader lines
    if (navigator.userAgent !== 'ReactSnap') {
      this.cleanMount();
      window.addEventListener("resize", this.updateDimensions);
    }
  }

  componentDidUpdate() {
    // change pathways border radius
    if (this.state.pathways && !this.state.lines.length && navigator.userAgent !== 'ReactSnap') {
      this.setPathways();
    }
  }

  componentWillUnmount() {
    if (navigator.userAgent !== 'ReactSnap') {
      this.clearPathways();
      window.removeEventListener("resize", this.updateDimensions);
    }
  }

  // Event handlers
  // ------------------------------------------------------------------------ //
  directoryNav = e => {
    if (e) e.preventDefault()
    this.props.dispatch(push('/directory'))
  }

  searchAndNav = (e, val) => {
    if (e) e.preventDefault()
    this.props.dispatch(setSearch({ search: val }));

    if (this.props.location.pathname.indexOf('directory') < 0) {
      this.directoryNav(null)
    }
  }

  // Class methods
  // ------------------------------------------------------------------------ //
  clearPathways = () => {
    let { pathways } = this.state;
    if (pathways) {
      Object.keys(pathways).forEach(line => {
        pathways[line].remove();
      })
    }
  }

  mountLines = () => {
    let refs = {
      heroRef: this.heroRef,
      quoteRef: this.quoteRef,
      reportBtnRef: this.reportBtnRef,
      gratitudeRef: this.gratitudeRef,
      nonopGratisLeftRef: this.nonopGratisLeftRef,
      nonopGratisRightRef: this.nonopGratisRightRef
    }

    this.setState({
      pathways: reportLeaderLines(window.innerWidth, refs)
    });
  }

  cleanMount = () => {
    this.clearPathways();
    this.setState({
      width: window.innerWidth,
      pathways: null
    }, () => {
      this.mountLines()
    })
  }

  updateDimensions = () => {
    this.cleanMount();
    this.setPathways();
    // this.forceUpdate()
  }

  setPathways = () => {
    let lines = Array.from(document.getElementsByClassName(`leader-line-line-path`))
      .map(line => {
        try {
          line.setAttribute('d', addArc(line.getAttribute('d'), 50));
        } catch (e) {
        }
        return line;
      }
      ).filter(path => path)

    this.setState({lines})
  }

  assignRefFunc = refEle => {
    const self = this;
    return ref => {
      self[refEle] = ref;
    }
  }

  // Render methods
  // ------------------------------------------------------------------------ //
  render() {
    return (
      <div className="report">
        <section
          className={`report__hero`}>
          <div className={`report__hero-depict`}>
            <h1>The Report</h1>
            <p>To address the multi-faceted and systemic challenges that LA's Opportunity Youth experience, <strong>Elevate</strong> identifies cross-sector efforts that involve nonprofit organizations, k-12 education, workforce investment, post-secondary education and creative industries.</p>
            <Button
              refFunc={this.assignRefFunc('reportBtnRef')}
              className="report__button"
              link={'/data/Elevate_Report_2018.pdf'}
              value="Read the report"
            />
            <div
              ref={ref => this[`heroRef`] = ref}
              className={`report__hero-dumb`}/>
          </div>
          <article className={`report__hero-info`}>
            <p>To address the multi-faceted and systemic challenges that LA's Opportunity Youth experience, <strong>Elevate</strong> identifies cross-sector efforts that involve nonprofit organizations, k-12 education, workforce investment, post-secondary education and creative industries.</p>
          </article>
        </section>

        <section
          className="report__testimony"
          ref={ref => this.quoteRef = ref}>
          <div className="report__testimony-portrait">
            <div className="report__testimony-img">
              <LazyLoad height={'100%'}>
                <img src={Musician} alt="student music"/>
              </LazyLoad>
            </div>
          </div>
          <article className="report__quote">
            <q className="report__quote-content">
              "I feel all of the elements are here in LA. The challenge is connecting the dots. Everyone is working in silos and is searching for the piece they don't have..."
            </q>
            <div className="report__quote-quoter">
              <p><strong>Denise Grande</strong></p>
              {/* <a href="/directory"
                onClick={e => this.searchAndNav(e, 'los angeles county arts commission')}>Los Angeles County Arts Commission</a> */}
              <Link to="/details/Los Angeles County Arts Commission">Los Angeles County Arts Commission</Link>
            </div>
          </article>
        </section>

        <section className="report__facilitate">
          <div className="report__img-overlay">
            <LazyLoad height={'100%'}>
              <img src={facilitateBackground} alt="facilitate"/>
            </LazyLoad>
          </div>
          <article className="report__facilitate-details">
            <h2 className="report__facilitate-headline">Elevate facilitates a cross-sector approach.</h2>
            <p className="report__facilitate-content">No one sector, agency or organization can help every young person gain access to the learning opportunities that lead to participation in LA's growing creative economy. It requires a cross-sector approach, where institutions and agencies work together to help young people complete high school, take the next steps in their postsecondary education, then find and retain fulfilling jobs in the creative industry. These efforts strengthen our local economy and support our most vulnerable youth.</p>
          </article>
        </section>

        <section className="report__organizations">
          <article className="report__organizations-count">
            <div className="report__count-blurb">
              <span>140+</span>
              <br/>
              <span>organizations</span>
              <h2>and counting have been identified in the LA region</h2>
            </div>
            <div className="report__count-cta">
              <Button
                className="report__button"
                onClick={this.directoryNav}
                value="Explore the directory"
              />
            </div>
          </article>
          <article className="report__organizations-details">
            <p>artworxLA collected data from interviews with regional leaders, advocates and providers -- resulting in this online resource, <strong>Elevate</strong>, and the accompanying <a target="_blank" href="/data/Elevate_Report_2018.pdf" rel="noopener noreferrer">report.</a></p>
            <p>Organizations that have been officially interviewed by artworxLA are shown in the <Link to="/directory">directory</Link> with a badge:</p>
            <div className="report__organizations-verified">
              <img src={Verified} alt="interviewed"/>
            </div>
          </article>
        </section>

        <section className="report__gratitude">
          <div className="report__gratitude-shout">
            <div
              ref={ref => this[`nonopGratisLeftRef`] = ref}
              className={`report__nonop-left`}/>
            <div
            className="report__gratitude-title"
            ref={ref => this.gratitudeRef = ref}>
              <h2>A great deal of gratitude is owed to the following people and organizations who brought this work to life:</h2>
            </div>
            <div
              ref={ref => this[`nonopGratisRightRef`] = ref}
              className={`report__nonop-right`}/>
          </div>
          <div className="report__gratitude-mentions">
            <div>
              <a target="_blank" href="https://www.artworxla.org/" rel="noopener noreferrer"><strong>artworxLA</strong></a>
              <p>Cynthia Campoy Brophy, Shelby Williams-Gonzalez, Paul Ulukpo</p>
            </div>
            <div>
              <p><strong>Marisa Saunders</strong></p>
              <p>Sr. Researcher, GSE&IS, UCLA</p>
            </div>
            <div>
              <a target="_blank" href="http://sisumedia.com/" rel="noopener noreferrer"><strong>Sisu, Inc.</strong></a>
              <p>Coleen McKenna-Austin, John Bozzalla, Guild Copeland, Jo Ngan, Steven Waller, Blake Watkins</p>
            </div>
            <p>Funded by <a target="_blank" href="https://www.irvine.org/" rel="noopener noreferrer"><strong>The James Irvine Foundation</strong></a>, with special thanks to Senior Program Officer Kelley D. Gulley</p>
          </div>
        </section>
      </div>
    );
  }
}

export default connect(null)(Report);



// WEBPACK FOOTER //
// ./src/components/Report/Report.js